import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { PaymentMethodsUI } from "@grandvisionhq/payments";
import { Footer } from "../../modules/Footer/modules/Footer/Footer.js";
import { LoaderModal } from "../../modules/LoaderModal/modules/LoaderModal/LoaderModal.js";
import { StepNames } from "../../models/models/shared.js";
const StepPayment = ({
  labels,
  onNextClick,
  onPrevClick,
  selectedPaymentMethod,
  onPaymentMethodSelected,
  onHandlePayment,
  cartId,
  qrCodeForm,
  isOrderInProgress,
  selectedDonation,
  onDonationSelected,
  totalPrice
}) => /* @__PURE__ */ React.createElement("div", { className: "checkout-step checkout-step--payment" }, /* @__PURE__ */ React.createElement(LoaderModal, { isModalOpen: isOrderInProgress, subheading: labels.paymentInProgress }), /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "checkout-step__title" }, labels.paymentMethodTitle), labels.paymentMethodSecure && /* @__PURE__ */ React.createElement("div", { className: "checkout-step__subtitle" }, labels.paymentMethodSecure), /* @__PURE__ */ React.createElement(
  PaymentMethodsUI,
  {
    cartId,
    onPaymentMethodSelected,
    selectedDonation,
    onDonationSelected,
    paymentMethodName: selectedPaymentMethod ?? "",
    onHandlePayment,
    qrCodeForm,
    isOrderInProgress,
    totalPrice
  }
), /* @__PURE__ */ React.createElement(
  Footer,
  {
    selectedPaymentMethod,
    isNextStepHidden: true,
    stepName: StepNames.Payment,
    onPrevStep: onPrevClick,
    onNextStep: onNextClick
  }
));
export {
  StepPayment
};
//# sourceMappingURL=StepPayment.js.map
